import {
  getInitFormData,
} from './utils.js';

export default {
  name: 'SolePropGForm',
  model: {
    prop: 'formData',
    event: 'change'
  },  
  props: [
    'formData',
    'toggleContact', // 控制表单字段的显示隐藏 eg: moreContact
    'labelArray',    // BdoRadio component parameter (BdoRadio 组件按钮文案)
    'mode',          // BdoRadio component parameter (BdoRadio 组件是否必选)
    'toggleAcr',     // acrNumber show hidden ( acrNumber 显示隐藏)
    'selectOptions', // select option  (下拉框选项)
    'agencyBanking', // BusinessNature下来列表选择
    'disabled',
  ],
  data() {
    return {
      dFormData: {},
      options: {},
      bdoRadioLabelArray: [],
      bdoRadioMode: true,
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      // 将v-model传入的数据更新到组件data
      this.dFormData = Object.assign({}, this.dFormData, this.$props.formData);
      this.options = this.selectOptions ? this.selectOptions : {};
      
      // BdoRadio component parameter
      this.bdoRadioLabelArray = this.labelArray ? this.labelArray : [];
      this.bdoRadioMode = this.mode ? this.mode : true;
    })
  },
  methods: {
    // 更新 formData
    updateDataForm(val){
      this.dFormData = Object.assign({}, val);
    },
  },
  watch: {
    dFormData: function() {
      this.$emit('change', this.$data.dFormData)
    },
  },
   // 模板字符串同时存在 ''  和 ""  而做的处理
  template: `<div><el-form class="pc-wrap SolePropG" label-position="top" ref="appForm" label-width="80px" :model="dFormData" :rules="formRules" :validateOnRuleChange="false" ><el-form-item   label="Unit No. and Building / House or Blk. No. and Street" prop="streetAddress"><el-input v-model="dFormData.streetAddress"  placeholder="Unit No. Building / No. Blk. Street" maxlength="128" :clearable="!disabled" :disabled="disabled"></el-input></el-form-item><el-form-item label="Province / State" prop="province"><bdo-select v-model="dFormData.province"  placeholder="Select Province / State" :options="options.province" :disabled="disabled" :filterable="true"></bdo-select></el-form-item><el-form-item   label="Subdivision / Village" prop="subdivision"><el-input v-model="dFormData.subdivision"  placeholder="Subdivision / Village" maxlength="128" :clearable="!disabled" :disabled="disabled"></el-input></el-form-item><el-form-item label="City / Municipality" prop="city"><bdo-select v-model="dFormData.city"  placeholder="Select City / Municipality" :options="options.city" :disabled="disabled" :filterable="true"></bdo-select></el-form-item><div class="el-form-item"></div><el-form-item label="Barangay" prop="barangay"><bdo-select v-model="dFormData.barangay"  placeholder="Select Barangay" :options="options.barangay" :disabled="disabled" :filterable="true"></bdo-select></el-form-item><el-form-item class="right-box"  label="Zip Code" prop="zipCode"><el-input v-model="dFormData.zipCode"  placeholder="Zip Code" maxlength="64" :clearable="!disabled" :disabled="disabled"></el-input></el-form-item></el-form></div>`,
};